import React, { useEffect, useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import api from "@/lib/api";
import { CAP, WEEKDAYS } from "@/data/constants";

export default function CapacityCalendar({ onSelectDay }) {
  const [cursor, setCursor] = useState(() => { const d = new Date(); return { y: d.getFullYear(), m: d.getMonth() + 1 }; });
  const [days, setDays] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    api.get(`/capacity/month?year=${cursor.y}&month=${cursor.m}`).then(({ data }) => setDays(data || [])).finally(() => setLoading(false));
  }, [cursor]);

  const firstDow = (new Date(cursor.y, cursor.m - 1, 1).getDay() + 6) % 7; // Mon=0
  const monthName = new Date(cursor.y, cursor.m - 1, 1).toLocaleDateString("fr-CH", { month: "long", year: "numeric" });
  const today = new Date().toISOString().slice(0, 10);
  const move = (dir) => setCursor((c) => { let m = c.m + dir, y = c.y; if (m < 1) { m = 12; y--; } if (m > 12) { m = 1; y++; } return { y, m }; });

  return (
    <div className="bg-white rounded-xl border border-slate-200 p-4 sm:p-6" data-testid="capacity-calendar">
      <div className="flex items-center justify-between mb-4">
        <h3 className="font-heading font-semibold text-lg text-slate-900 capitalize">{monthName}</h3>
        <div className="flex gap-1">
          <button onClick={() => move(-1)} className="h-8 w-8 rounded-md border border-slate-200 flex items-center justify-center hover:bg-slate-50" data-testid="cal-prev"><ChevronLeft className="h-4 w-4" /></button>
          <button onClick={() => move(1)} className="h-8 w-8 rounded-md border border-slate-200 flex items-center justify-center hover:bg-slate-50" data-testid="cal-next"><ChevronRight className="h-4 w-4" /></button>
        </div>
      </div>
      <div className="grid grid-cols-7 gap-1.5 sm:gap-2 text-center text-xs font-semibold text-slate-400 mb-2">
        {WEEKDAYS.map((d) => <div key={d}>{d.slice(0, 3)}</div>)}
      </div>
      <div className="grid grid-cols-7 gap-1.5 sm:gap-2">
        {Array.from({ length: firstDow }).map((_, i) => <div key={`e${i}`} />)}
        {days.map((d) => {
          const dd = parseInt(d.date.slice(-2), 10);
          const st = CAP[d.state];
          const past = d.date < today;
          const clickable = onSelectDay && d.state !== "full" && !past;
          return (
            <button key={d.date} disabled={!clickable} onClick={() => clickable && onSelectDay(d)} data-testid={`cal-day-${d.date}`}
              className={`aspect-square rounded-lg border text-sm flex flex-col items-center justify-center transition-all ${past ? "opacity-40 border-slate-100" : st.cell} ${clickable ? "cursor-pointer" : "cursor-default"}`}>
              <span className="font-medium">{dd}</span>
              <span className={`h-1.5 w-1.5 rounded-full mt-1 ${st.dot}`} />
            </button>
          );
        })}
      </div>
      <div className="mt-4 flex flex-wrap gap-4 text-xs">
        {Object.values(CAP).map((c) => <span key={c.label} className="flex items-center gap-1.5"><span className={`h-2 w-2 rounded-full ${c.dot}`} />{c.label}</span>)}
      </div>
    </div>
  );
}
